<template>
    <el-container id="tab" v-loading="leftLoading">
        <el-aside width="200px">
            <el-menu :default-openeds="defaultOpeneds" :default-active="defaultActive" @select="handleSelect">
                <el-submenu :index="item.id" v-for="item in leftList" :key="item.id">
                    <template slot="title">
                        <div class="submenu-title">
                            <span></span>
                            <p>{{item.messageTypeName}}</p>
                        </div>
                    </template>
                    <el-menu-item :index="it.messageTypeID" v-for="it in item.secondList" :key="it.id">
                        <div class="item-box">
                            <div class="item-left">
                                <i class="iconfont" :class="it.messageTypeIcon"></i>
                                <p>{{it.messageTypeName}}</p>
                            </div>
                            <div class="item-right">
                                <el-badge :value="it.messageCount" v-if="it.messageCount > 0" :max="999" slot="reference"></el-badge>
                            </div>
                        </div>
                    </el-menu-item>
                </el-submenu>
            </el-menu>
        </el-aside>
        <el-main>
            <ul class="nav-top">
                <li @click="handleClick(0)" :class="navIndex == 0 ? 'active' : ''">未读</li>
                <li class="bd"></li>
                <li @click="handleClick(1)" :class="navIndex == 1 ? 'active' : ''">全部</li>
            </ul>
            <div class="table-top">
                <el-checkbox :indeterminate="navList[navIndex].isIndeterminate" v-model="navList[navIndex].checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <span :style="{marginLeft: '40px', color: navList[navIndex].checked.length > 0 ? '#409EFF' : '#909399', cursor: 'pointer', fontSize: '14px'}" @click="toRead">标记为已读</span>
            </div>
            <div class="nav-table" v-loading="navList[navIndex].msgLoading">
                <el-scrollbar ref="scrollMenuRef" style="height: 100%;" v-if="navList[navIndex].list.length > 0">
                    <el-checkbox-group v-model="navList[navIndex].checked" @change="handleCheckedCitiesChange">
                        <div style="position: relative;" v-for="item in navList[navIndex].list" :key="item.id">
                            <el-checkbox class="table-check" :label="item.id"></el-checkbox>
                            <div class="table-box" @click="toDetail(item.id, item.isRead)">
                                <div class="box-top">
                                    <span style="width: 18px; height: 22px;"></span>
                                    <p style="font-size: 16px; font-weight: 600; margin-left: 15px;">{{item.messageTitle}}</p>
                                    <span v-if="item.sourceBillNo" style="font-size: 14px; color: #E6A23C;margin-left: 10px;">单号：{{item.sourceBillNo}}</span>
                                </div>
                                <div class="box-bottom">
                                    <div v-if="navIndex == 1">
                                        <el-tag size="mini" type="info" v-if="item.isRead == 'Y'">已读</el-tag>
                                        <el-tag size="mini" type="danger" v-else>未读</el-tag>
                                    </div>
                                    <el-link :style="{marginLeft: navIndex == 1 ? '15px' : '35px'}">{{item.messageContent}}</el-link>
                                    <span class="span">{{item.addDateTime}}</span>
                                </div>
                            </div>
                        </div>
                    </el-checkbox-group>
                </el-scrollbar>
                <div v-else style="position: relative; height: 100%">
                    <p class="zanwu">{{navIndex == 0 ? '暂无未读信息' : '暂无信息'}}</p>
                </div>
            </div>
            <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10, 20, 100]" :page-size="params.size" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="navList[navIndex].list.length > 0"></el-pagination>
        </el-main>
    </el-container>
</template>
<script>
    export default {
    components: {},
    data() {
        return {
            leftLoading: false,
            params: {
                page: 1,
                size: 20,
                messageType: '',
                isRead: '',
            },
            total: 0,
            navIndex: 0,
            navList: [{
                index: 0,
                list: [],
                checkAll: false,
                checked: [],
                isIndeterminate: false,
                page: 1,
                size: 20,
                total: 0,
                msgLoading: false
            }, {
                index: 1,
                list: [],
                checkAll: false,
                checked: [],
                isIndeterminate: false,
                page: 1,
                size: 20,
                total: 0,
                msgLoading: false
            }],
            leftList: [],
            defaultOpeneds: [],
            defaultActive: '',
        }
    },
    created() {
        this.getLeftList()
        // this.getTableData()
    },
    methods: {
        async getLeftList(isRefresh) {
            this.leftLoading = true
            const { data: res } = await this.$http.post('/Account/messageDefineVue/selectMessageTypeList.html')
            this.leftLoading = false
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.defaultOpeneds = []
            this.leftList = JSON.parse(res.result.data).map((item, index) => {
                this.defaultOpeneds.push(item.id)
                if(item.secondList.length > 0 && index == 0 && !isRefresh) this.params.messageType = item.secondList[0].messageTypeID
                return item
            })
            if(!isRefresh){
                this.defaultActive = this.params.messageType
                console.log(this.defaultActive)
            }
            this.getData()
        },
        async getUnreadMessage(isPagination) {
            if (!isPagination) {
                this.navList[this.navIndex].checked = []
                this.navList[this.navIndex].checkAll = false
                this.navList[this.navIndex].isIndeterminate = false
            }
            this.params.isRead = 'N'
            this.navList[0].msgLoading = true
            const { data: res } = await this.$http.post('/Account/messageDefineVue/selectMessageList.html', this.Qs.stringify(this.params))
            this.navList[0].msgLoading = false
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.navList[0].list = JSON.parse(res.result.data)
            this.navList[0].total = JSON.parse(res.result.total)
            this.navList[0].page = this.params.page
            this.navList[0].size = this.params.size
            this.total = JSON.parse(res.result.total)
        },
        async getAllMessage(isPagination) {
            if (!isPagination) {
                this.navList[this.navIndex].checked = []
                this.navList[this.navIndex].checkAll = false
                this.navList[this.navIndex].isIndeterminate = false
            }
            this.params.isRead = ''
            this.navList[1].msgLoading = true
            const { data: res } = await this.$http.post('/Account/messageDefineVue/selectMessageList.html', this.Qs.stringify(this.params))
            this.navList[1].msgLoading = false
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.navList[1].list = JSON.parse(res.result.data)
            this.navList[1].total = JSON.parse(res.result.total)
            this.navList[1].page = this.params.page
            this.navList[1].size = this.params.size
            this.total = JSON.parse(res.result.total)
        },
        handleSelect(key) {
            console.log(key);
            this.params.messageType = key
            this.params.page = 1
            this.getData()
        },
        handleCheckAllChange(val) {
            console.log(val)
            this.navList[this.navIndex].checked = val ? this.navList[this.navIndex].list.map(item => item.id) : [];
            console.log(this.navList[this.navIndex].checked)
            this.navList[this.navIndex].isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.navList[this.navIndex].checkAll = checkedCount === this.navList[this.navIndex].list.length;
            this.navList[this.navIndex].isIndeterminate = checkedCount > 0 && checkedCount < this.navList[this.navIndex].list.length;
        },
        handleSizeChange(size) {
            this.params.size = size
            this.getData(true)
        },
        handleCurrentChange(page) {
            this.params.page = page
            this.getData(true)
        },
        handleClick(index) {
            this.navIndex = index
            this.params.page = this.navList[this.navIndex].page
            this.params.size = this.navList[this.navIndex].size
            this.getData()
        },
        async toRead() {
            if(this.navList[this.navIndex].checked.length == 0) return false
            console.log(this.navList[this.navIndex].checked)
            let arr = []
            this.navList[this.navIndex].checked.map(item => {
                arr.push("'" + item + "'")
            })
            let str = arr.join(',')
            const loading = this.$loading({
                lock: true,
                text: '已读中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            const { data: res } = await this.$http.post('/Account/messageDefineVue/updateBatchMessageIsRead.html', this.Qs.stringify({id: str}))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success('消息已读成功')
            this.params.page = 1
            this.getLeftList(true)
        },
        async toDetail(id, isRead) {
            // console.log(id)
            let width = window.top.document.browser.availiframeWidth.value,
            height = window.top.document.browser.availiframeHeight.value
            const loading = this.$loading({
                lock: true,
                text: '跳转中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            // if(isRead == 'N') {
            //     const { data: res } = await this.$http.post('/Account/messageDefineVue/updateBatchMessageIsRead.html', this.Qs.stringify({id: id}))
            //     if (res.code != 'success') return this.$message.error(res.message)
            //     this.$message.success(res.message)
            //     this.params.page = 1
            //     this.getData()    
            // }
            const { data: res } = await this.$http.post('/Account/messageDefineVue/selectMessageAndOrderDetailById.html', this.Qs.stringify({id: id}))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success('消息已读成功')
            this.params.page = 1
            this.getLeftList(true)
            let { activeName, billNo, activeTabName, jumpPageType, isJump, tabsName, tag } = JSON.parse(JSON.parse(res.result).data)
            if (isJump == 'N') return false
            if (jumpPageType == 'A') {
                top.addPanel('订单管理', `/Account/sys/presellProcess/orderManagement.html?billNo=${ billNo }&activeName=${ activeName }&activeTabName=${ activeTabName }`, width, height, true)
            } else if (jumpPageType == 'B') {
                top.addPanel('调拨查询', `/Account/sys/billSearchVue/indexVue.html?billNo=${ billNo }&tabsName=${ tabsName }&tag=${ tag }`, width, height, true)
            } else if (jumpPageType == 'C') {
                top.addPanel('订单审核', `/yunsierp3/index.html#/orderAudit/list?billNo=${ billNo }`, width, height, true)
            }
        },
        getData(isPagination) {
            if(this.navIndex == 0) {
                this.getUnreadMessage(isPagination)
            } else {
                this.getAllMessage(isPagination)
            }
        }
    }
}
</script>
<style type="text/css" src="@/assets/font/info/iconfont.css"></style>
<style scoped lang="less">
#tab {
    height: calc(100vh - 20px);

    /deep/.el-submenu__title {
        height: 46px;
        line-height: 46px;
        padding: 0 10px !important;
    }

    /deep/.el-menu-item {
        padding: 0 20px !important;
        height: 36px;
        line-height: 36px;
    }

    .el-menu {
        height: 100%;
    }

    .submenu-title {
        display: flex;
        flex-direction: row;
        align-items: center;

        span {
            width: 3px;
            height: 16px;
            background-color: #E6A23C;
            margin-right: 10px;
        }

        p {
            color: #E6A23C;
            font-size: 16px;
            font-weight: bolder;
        }
    }

    .item-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .item-left {
            display: flex;
            flex-direction: row;
            align-items: center;

            .iconfont {
                font-size: 18px;
                margin-right: 5px;
                color: #606266;
            }
        }

        .item-right {
            /deep/ .el-badge__content {
                transform: scale(0.8);
            }
        }
    }

    .el-main {
        padding: 0 0 0 12px;

        .nav-top {
            display: flex;
            flex-direction: row;
            align-items: center;

            li {
                width: 50px;
                font-size: 16px;
                text-align: center;
                font-weight: normal;
                cursor: pointer;
                line-height: 30px;

                &.active {
                    color: #409EFF;
                    font-weight: bolder;
                    font-size: 18px;
                }
            }

            .bd {
                width: 2px;
                height: 23px;
                margin: 0 10px;
                background-color: #e6e6e6;
                cursor: text;
            }
        }

        .table-top {
            padding: 16px 0 6px;
        }

        /deep/ .el-checkbox__inner {
            width: 18px;
            height: 18px;
        }

        /deep/ .el-checkbox__inner::after {
            height: 9px;
            width: 5px;
            left: 5px;
        }

        /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
            top: 7px;
        }

        .nav-table {
            height: calc(100% - 30px - 32px - 45px);

            .table-check {
                position: absolute;
                top: 11px;
                z-index: 1;

                /deep/.el-checkbox__label {
                    display: none;
                }
            }

            .table-box {
                z-index: 0;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 10px 0;
                border-bottom: 1px solid #e6e6e6;
                cursor: pointer;

                .box-top {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-bottom: 10px;
                }

                .box-bottom {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .span {
                        font-size: 14px;
                        margin-left: 30px;
                        color: #909399;
                    }
                }
            }
        }

        .zanwu {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            line-height: 60px;
            color: #909399;
        }
    }
}

a:hover {
    text-decoration: none;
}
</style>